import { render, staticRenderFns } from "./Detail-Sell.vue?vue&type=template&id=5b527348&scoped=true"
import script from "./Detail-Sell.vue?vue&type=script&lang=js"
export * from "./Detail-Sell.vue?vue&type=script&lang=js"
import style0 from "./Detail-Sell.vue?vue&type=style&index=0&id=5b527348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b527348",
  null
  
)

export default component.exports